import React from 'react';
import { useAtomValue } from 'jotai';
import { currentFrameAtom } from '../../../labelling-v2/atoms/video-playback-atoms';
import useContentCanvas from '../../providers/hooks/use-content-canvas';
import usePDF from '../../providers/hooks/use-pdf';
type PropsT = {
  pdfUrl: string | undefined | null;
  onLoad: (width: number, height: number) => void;
  onError: () => void;
};
const PDF = ({
  pdfUrl,
  onLoad,
  onError
}: PropsT) => {
  const {
    renderPDFFrame,
    getPage
  } = usePDF();
  const {
    getCanvasContext
  } = useContentCanvas();
  const currentFrame = useAtomValue(currentFrameAtom);
  React.useEffect(() => {
    // getCanvasContext() is called inside the effect (after DOM commit) so that
    // canvasRef.current is guaranteed to be set. Calling it at render time
    // returns null on the first render because the canvas element is not yet commit
    // null on the first render because the canvas element is not yet commit
    // to the DOM, causing onLoad/onError to never fire.
    const pdfCanvas = getCanvasContext();
    (async () => {
      try {
        const page = await getPage(currentFrame + 1);
        if (page && pdfCanvas) {
          const [x_start, y_start, x_end, y_end] = page.view;
          onLoad(x_end - x_start, y_end - y_start);
          // Have to first set the stage and canvas size, then render the pdf. Otherwise the pdf rendering will be messed up
          setTimeout(async () => {
            renderPDFFrame(currentFrame + 1, pdfCanvas);
          }, 0);
        }
      } catch {
        onError();
      }
    })();
  }, [pdfUrl, currentFrame, onLoad, renderPDFFrame, onError, getPage, getCanvasContext]);
  return null;
};
export default PDF;